import React from 'react';

function LineItem({ item, onUpdate }) {
  const lineTotal = item.quantity * item.rate;

  return (
    <div className={`line-item ${item.enabled ? 'is-active' : ''}`}>
      <label className="switch" aria-label={`Include ${item.name}`}>
        <input
          type="checkbox"
          checked={item.enabled}
          onChange={(event) => onUpdate('enabled', event.target.checked)}
        />
        <span />
      </label>

      <div className="line-description">
        <strong>{item.name}</strong>
        <span>{item.detail}</span>
      </div>

      <label className="compact-field">
        <span>Quantity</span>
        <input
          type="number"
          min="0"
          step="1"
          disabled={!item.enabled}
          value={item.quantity}
          onChange={(event) => onUpdate('quantity', Number(event.target.value))}
        />
      </label>

      <label className="compact-field">
        <span>Unit rate</span>
        <div className="compact-money">
          <b>$</b>
          <input
            type="number"
            min="0"
            step="50"
            disabled={!item.enabled}
            value={item.rate}
            onChange={(event) => onUpdate('rate', Number(event.target.value))}
          />
        </div>
      </label>

      <div className="line-total">
        <span>Line total</span>
        <strong>
          ${lineTotal.toLocaleString('en-US', { maximumFractionDigits: 0 })}
        </strong>
      </div>
    </div>
  );
}

export default LineItem;